import React from 'react';
import { ThemeProvider } from 'styled-components';
import { useQuery } from '@apollo/client';
import { EmptyTag } from '@quikr/ui';
import { GlobalStyle } from '@quikr/ui/theme';
import CommonFloor from '@quikr/ui/theme/CommonFloor';
import Quikr from '@quikr/ui/theme/Quikr';
import Routes from '../../routes';
import Header from '../../components/common/Header';
import Footer from '../../components/common/Footer';
import { common } from '../../gql/common';
import { AppProvider } from '../../context';
import { AnalyticsProvider } from '../../context/ga';
import { AnalyticsConfig } from '../../constants/analytics';

const App = () => {
  const { data: { isMobile, isWebview, source } = {}, loading } = useQuery(common);
  // eslint-disable-next-line
  const isQuikr = __ANALYTICS_DOMAIN_CLIENT__ === 'Quikr';
  if (loading) return null;
  return (
    <AppProvider>
      <AnalyticsProvider config={AnalyticsConfig(isMobile, source)}>
        <EmptyTag />
        <ThemeProvider theme={isQuikr ? Quikr : CommonFloor}>
          <GlobalStyle />
          {!isWebview && <Header host={isQuikr ? 'Quikr' : 'CommonFloor'} />}
          <Routes />
          {!isWebview && <Footer host={isQuikr ? 'Quikr' : 'CommonFloor'} />}
        </ThemeProvider>
      </AnalyticsProvider>
    </AppProvider>
  );
};
export default App;
